import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import constants from '../config';
import { resolveCardImage } from '../utils/resolveImage';
import AuthService from './AuthService';
import AuthModalContext from '../contexts/AuthModalContext';
import CartContext from '../contexts/CartContext';
import { GameContext } from '../contexts/GameContext';
import { renderRarityBadge } from '../utils/rarityBadge';
import ThemeToggle from './ThemeToggle';
import logoLight from './assets/logo.svg';
import logoDark from './assets/logo-gold.svg';

const Auth = new AuthService();

class LayoutNavbar extends Component {
  static contextType = AuthModalContext;

  constructor(props) {
    super(props);
    var initialProfileImage = null;
    var initialUsername = '';
    var initialLoggedIn = false;
    try {
      if (Auth.loggedIn()) {
        var user = Auth.getProfile();
        initialLoggedIn = true;
        initialProfileImage = localStorage.getItem('primal_profile_image') || (user.profilePic ? constants.DOMAIN + '/' + user.profilePic : null);
        if (user.username) initialUsername = user.username;
      }
    } catch (e) { /* ignore */ }
    this.state = {
      isLoggedIn: initialLoggedIn,
      searchQuery: '',
      profileImage: initialProfileImage,
      username: initialUsername,
      notificationCount: parseInt(localStorage.getItem('primal_notif_count') || '0', 10),
      suggestions: [],
      showSuggestions: false,
      suggestionsLoading: false,
      profileDropdownOpen: false,
      notifDropdownOpen: false,
      unreadMessages: 0,
      priceWatches: [],
      dismissedNotifs: {},
      lastPollTime: null,
      bellAnimating: false,
      cartAnimating: false,
      messageAnimating: false,
      verified: true,
      verificationBannerDismissed: sessionStorage.getItem('primal_verify_dismissed') === 'true',
      resendingVerification: false,
      userRole: 'user',
      systemNotifications: [],
      announcement: null,
      announcementDismissed: false,
      mobileSearchOpen: false,
      mobileSearchClosing: false,
      mobileCartOpen: false,
      mobileCartClosing: false,
      searchFocused: false,
      accountSheetOpen: false,
      accountSheetClosing: false,
      keyboardOpen: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleAuthStateChanged = this.handleAuthStateChanged.bind(this);
    this.handleProfileUpdated = this.handleProfileUpdated.bind(this);
    this.handleCartUpdated = this.handleCartUpdated.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleThemeChanged = this.handleThemeChanged.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this._handleFocusIn = this._handleFocusIn.bind(this);
    this._handleFocusOut = this._handleFocusOut.bind(this);
    this.openMobileSearch = this.openMobileSearch.bind(this);
    this.closeMobileSearch = this.closeMobileSearch.bind(this);
    this.openMobileCart = this.openMobileCart.bind(this);
    this.closeMobileCart = this.closeMobileCart.bind(this);
    this.searchRef = React.createRef();
    this._scrollY = 0;
    this.mobileSearchRef = React.createRef();
    this.mobileCartRef = React.createRef();
    this.profileDropdownRef = React.createRef();
    this.notifDropdownRef = React.createRef();
    this._searchTimer = null;
    this._pollTimer = null;
    this._pendingFetches = 0;
    this._searchCloseTimer = null;
    this._cartCloseTimer = null;
  }

  componentDidMount() {
    window.addEventListener('authStateChanged', this.handleAuthStateChanged);
    window.addEventListener('profileUpdated', this.handleProfileUpdated);
    window.addEventListener('cartUpdated', this.handleCartUpdated);
    window.addEventListener('themeChanged', this.handleThemeChanged);
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('focusin', this._handleFocusIn);
    document.addEventListener('focusout', this._handleFocusOut);
    try {
      var dismissed = JSON.parse(localStorage.getItem('primal_dismissed_notifs') || '{}');
      this.setState({ dismissedNotifs: dismissed });
    } catch (e) { /* ignore */ }
    this.checkAuthState();
    this.fetchAnnouncement();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (this.state.mobileSearchOpen && !this.state.mobileSearchClosing) {
        this.setState({ mobileSearchOpen: false, mobileSearchClosing: false, showSuggestions: false, searchQuery: '' });
        this.unlockScroll();
      }
      if (this.state.mobileCartOpen && !this.state.mobileCartClosing) {
        this.setState({ mobileCartOpen: false, mobileCartClosing: false });
        this.unlockScroll();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('authStateChanged', this.handleAuthStateChanged);
    window.removeEventListener('profileUpdated', this.handleProfileUpdated);
    window.removeEventListener('cartUpdated', this.handleCartUpdated);
    window.removeEventListener('themeChanged', this.handleThemeChanged);
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('focusin', this._handleFocusIn);
    document.removeEventListener('focusout', this._handleFocusOut);
    clearTimeout(this._keyboardTimer);
    if (this._searchTimer) clearTimeout(this._searchTimer);
    if (this._searchCloseTimer) clearTimeout(this._searchCloseTimer);
    if (this._cartCloseTimer) clearTimeout(this._cartCloseTimer);
    this.stopSalePolling();
    if (this.state.accountSheetOpen || this.state.mobileSearchOpen || this.state.mobileCartOpen) this.unlockScroll();
  }

  handleClickOutside(e) {
    if (this.searchRef.current && !this.searchRef.current.contains(e.target) &&
        !(this.mobileSearchRef.current && this.mobileSearchRef.current.contains(e.target))) {
      this.setState({ showSuggestions: false });
    }
    if (this.profileDropdownRef.current && !this.profileDropdownRef.current.contains(e.target)) {
      this.setState({ profileDropdownOpen: false });
    }
    if (this.notifDropdownRef.current && !this.notifDropdownRef.current.contains(e.target)) {
      this.setState({ notifDropdownOpen: false });
    }
  }

  _handleFocusIn(e) {
    var tag = e.target && e.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
      clearTimeout(this._keyboardTimer);
      if (!this.state.keyboardOpen) this.setState({ keyboardOpen: true });
    }
  }

  _handleFocusOut() {
    // Debounce: focusout fires before focusin when tapping between inputs.
    // Wait 80ms to see if another input gets focus before hiding the tab bar.
    clearTimeout(this._keyboardTimer);
    this._keyboardTimer = setTimeout(function() {
      if (this.state.keyboardOpen) this.setState({ keyboardOpen: false });
    }.bind(this), 80);
  }

  handleSearchInput(e) {
    var query = e.target.value;
    this.setState({ searchQuery: query });
    if (this._searchTimer) clearTimeout(this._searchTimer);
    if (query.trim().length < 2) {
      this.setState({ suggestions: [], showSuggestions: false });
      return;
    }
    this.setState({ suggestionsLoading: true });
    this._searchTimer = setTimeout(() => {
      const gameSlug = this._gameCtx && this._gameCtx.currentGame && this._gameCtx.currentGame.slug;
      const gameParam = gameSlug ? '&game=' + encodeURIComponent(gameSlug) : '';
      fetch(constants.DOMAIN + '/api/v1/guest/cards/search?search=' + encodeURIComponent(query.trim()) + gameParam, {
        mode: 'cors',
        method: 'GET',
      })
        .then(r => r.json())
        .then(res => {
          this.setState({
            suggestions: res.cards || [],
            showSuggestions: true,
            suggestionsLoading: false,
          });
        })
        .catch(() => {
          this.setState({ suggestionsLoading: false });
        });
    }, 250);
  }

  handleSuggestionClick(cardId) {
    this.setState({ showSuggestions: false, searchQuery: '', mobileMenuOpen: false });
    if (this.state.mobileSearchOpen) this.closeMobileSearch();
    this.props.history.push('/card/' + cardId);
  }

  handleThemeChanged() {
    this.forceUpdate();
  }

  handleAuthStateChanged() {
    this.checkAuthState();
  }

  handleCartUpdated() {
    var self = this;
    self.setState({ cartAnimating: true });
    setTimeout(function() { self.setState({ cartAnimating: false }); }, 500);
  }

  handleProfileUpdated() {
    // Skip reading stale JWT (which has old profilePic) — go straight to fetching fresh profile
    if (Auth.loggedIn()) {
      try {
        const user = Auth.getProfile();
        if (user && user._id) this.fetchProfile(user._id);
      } catch (err) { /* ignore */ }
    }
  }

  checkAuthState() {
    if (Auth.loggedIn()) {
      this.setState({ isLoggedIn: true });
      try {
        const user = Auth.getProfile();
        // Check verified status from localStorage
        var verifiedStr = localStorage.getItem('primal_verified');
        var isVerified = verifiedStr !== null ? JSON.parse(verifiedStr) : true;
        this.setState({
          verified: isVerified,
          userRole: user.role || 'user',
          profileImage: localStorage.getItem('primal_profile_image') || (user.profilePic ? constants.DOMAIN + '/' + user.profilePic : this.state.profileImage),
          username: user.username || this.state.username,
        });
        this._pendingFetches = 3;
        this.fetchProfile(user._id);
        this.fetchNotifications();
        this.fetchPriceWatches();
        this.startSalePolling();
      } catch (err) {
        console.log('Token decode error:', err);
        this.setState({ isLoggedIn: false, profileImage: null, username: '', notificationCount: 0, verified: true, userRole: 'user' });
        this.stopSalePolling();
      }
    } else {
      sessionStorage.removeItem('primal_verify_dismissed');
      localStorage.removeItem('primal_profile_image');
      this.setState({ isLoggedIn: false, profileImage: null, username: '', notificationCount: 0, verified: true, verificationBannerDismissed: false, userRole: 'user' });
      this.stopSalePolling();
    }
  }

  fetchAnnouncement() {
    var self = this;
    fetch(constants.DOMAIN + '/api/v1/announcement', { mode: 'cors', method: 'GET' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.enabled) {
          self.setState({ announcement: data });
        } else {
          self.setState({ announcement: null });
        }
      })
      .catch(function() { /* ignore */ });
  }

  handleLogout() {
    Auth.logout();
    this.stopSalePolling();
    sessionStorage.removeItem('primal_verify_dismissed');
    localStorage.removeItem('primal_profile_image');
    localStorage.removeItem('primal_notif_count');
    this.setState({ isLoggedIn: false, profileImage: null, username: '', notificationCount: 0, mobileMenuOpen: false, priceWatches: [], lastPollTime: null, bellAnimating: false, verified: true, verificationBannerDismissed: false });
    window.dispatchEvent(new Event('authStateChanged'));
    const protectedRoutes = ['/settings', '/sell', '/edit'];
    const currentPath = this.props.location.pathname;
    if (protectedRoutes.some(route => currentPath.startsWith(route))) {
      this.props.history.push('/');
    }
  }

  handleResendVerification() {
    this.setState({ resendingVerification: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/users/resend-verification', {
      mode: 'cors',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function() {
        alert('Verification email sent! Please check your inbox.');
      })
      .catch(function(err) {
        if (err && err.response) {
          err.response.json().then(function(data) {
            alert(data.error || 'Could not send verification email. Please try again later.');
          }).catch(function() {
            alert('Could not send verification email. Please try again later.');
          });
        } else {
          alert('Could not send verification email. Please try again later.');
        }
      })
      .then(() => {
        this.setState({ resendingVerification: false });
      });
  }

  fetchProfile(userId) {
    Auth.fetch(`${constants.DOMAIN}/api/v1/users/${userId}`, {
      mode: 'cors',
      method: 'GET',
    })
      .then(res => {
        var freshImage = `${constants.DOMAIN}/${res.profile.image}`;
        localStorage.setItem('primal_profile_image', freshImage);
        this.setState({
          profileImage: freshImage,
          username: res.profile.userName,
          socialNotifications: res.notifications || [],
          replies: res.replies || [],
          followers: res.profile.followers || [],
          observedFollowers: res.profile.observedFollowers || 0,
          systemNotifications: res.systemNotifications || [],
        }, () => this.calculateNotifications());
      })
      .catch(err => console.log(err));
  }

  fetchNotifications() {
    Auth.fetch(`${constants.DOMAIN}/api/v1/transactions/list`, {
      mode: 'cors',
      method: 'GET',
    })
      .then(res => {
        this.setState({
          sales: res.sales || [],
          marketed: res.marketed || [],
          purchased: res.purchased || [],
          reviews: res.reviews || [],
        }, () => this.calculateNotifications());
      })
      .catch(err => console.log(err));
  }

  fetchPriceWatches() {
    Auth.fetch(`${constants.DOMAIN}/api/v1/pricewatches`, {
      mode: 'cors',
      method: 'GET',
    })
      .then(res => {
        this.setState({ priceWatches: res.watches || [] }, () => this.calculateNotifications());
      })
      .catch(() => {});
  }

  lockScroll() {
    this._scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this._scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, this._scrollY);
  }

  openMobileSearch() {
    if (this._cartCloseTimer) { clearTimeout(this._cartCloseTimer); this._cartCloseTimer = null; }
    if (this.state.mobileCartOpen || this.state.mobileCartClosing) {
      this.setState({ mobileCartOpen: false, mobileCartClosing: false });
    }
    if (this._searchCloseTimer) { clearTimeout(this._searchCloseTimer); this._searchCloseTimer = null; }
    this.lockScroll();
    this.setState({ mobileSearchOpen: true, mobileSearchClosing: false });
  }

  closeMobileSearch() {
    if (this._searchCloseTimer) { clearTimeout(this._searchCloseTimer); this._searchCloseTimer = null; }
    this.setState({ mobileSearchClosing: true });
    this.unlockScroll();
    this._searchCloseTimer = setTimeout(function() {
      this._searchCloseTimer = null;
      this.setState({ mobileSearchOpen: false, mobileSearchClosing: false, showSuggestions: false, searchQuery: '' });
    }.bind(this), 300);
  }

  openMobileCart() {
    if (this._searchCloseTimer) { clearTimeout(this._searchCloseTimer); this._searchCloseTimer = null; }
    if (this.state.mobileSearchOpen || this.state.mobileSearchClosing) {
      this.setState({ mobileSearchOpen: false, mobileSearchClosing: false, showSuggestions: false, searchQuery: '' });
    }
    if (this._cartCloseTimer) { clearTimeout(this._cartCloseTimer); this._cartCloseTimer = null; }
    this.lockScroll();
    this.setState({ mobileCartOpen: true, mobileCartClosing: false });
  }

  closeMobileCart() {
    if (this._cartCloseTimer) { clearTimeout(this._cartCloseTimer); this._cartCloseTimer = null; }
    this.setState({ mobileCartClosing: true });
    this.unlockScroll();
    this._cartCloseTimer = setTimeout(function() {
      this._cartCloseTimer = null;
      this.setState({ mobileCartOpen: false, mobileCartClosing: false });
    }.bind(this), 300);
  }

  calculateNotifications() {
    // During initial load, wait for all fetches before recalculating
    if (this._pendingFetches > 0) {
      this._pendingFetches--;
      if (this._pendingFetches > 0) return; // still waiting for other fetches
    }
    // Derive count from the filtered notification items (respects dismiss state)
    var count = this.getNotificationItems().length;
    if (count !== this.state.notificationCount) {
      localStorage.setItem('primal_notif_count', String(count));
      this.setState({ notificationCount: count });
    }
  }

  dismissPriceWatch(watchId) {
    Auth.fetch(`${constants.DOMAIN}/api/v1/pricewatches/${watchId}/dismiss`, {
      mode: 'cors',
      method: 'POST',
    })
      .then(() => this.fetchPriceWatches())
      .catch(() => {});
  }

  dismissNotif(key) {
    var dismissed = Object.assign({}, this.state.dismissedNotifs);
    dismissed[key] = true;
    this.setState({ dismissedNotifs: dismissed }, () => this.calculateNotifications());
    try { localStorage.setItem('primal_dismissed_notifs', JSON.stringify(dismissed)); } catch (e) { /* ignore */ }
  }

  dismissSystemNotification(notifId, key) {
    var self = this;
    // Optimistically remove from state
    var updated = this.state.systemNotifications.filter(function(n) { return n._id !== notifId; });
    this.setState({ systemNotifications: updated }, function() { self.calculateNotifications(); });
    // Also dismiss locally so it doesn't reappear from stale data
    this.dismissNotif(key);
    // Mark as read on server
    Auth.fetch(constants.DOMAIN + '/api/v1/users/notifications/' + notifId + '/dismiss', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
    }).catch(function() { /* silent */ });
  }

  markAllRead() {
    var items = this.getNotificationItems(true);
    var dismissed = Object.assign({}, this.state.dismissedNotifs);
    items.forEach(function(item) {
      if (item.key) dismissed[item.key] = true;
      if (item.dismissId) dismissed['pw-' + item.dismissId] = true;
    });
    this.setState({ dismissedNotifs: dismissed, systemNotifications: [] }, () => this.calculateNotifications());
    try { localStorage.setItem('primal_dismissed_notifs', JSON.stringify(dismissed)); } catch (e) { /* ignore */ }
    // Also dismiss all triggered price watches via API
    var s = this.state;
    if (s.priceWatches) {
      s.priceWatches.forEach(function(w) {
        if (w.triggered && !w.dismissed) {
          Auth.fetch(`${constants.DOMAIN}/api/v1/pricewatches/${w._id}/dismiss`, {
            mode: 'cors',
            method: 'POST',
          }).catch(function() {});
        }
      });
    }
    // Also dismiss all system notifications via API
    items.forEach(function(item) {
      if (item.systemNotifId) {
        Auth.fetch(constants.DOMAIN + '/api/v1/users/notifications/' + item.systemNotifId + '/dismiss', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
        }).catch(function() {});
      }
    });
  }

  startSalePolling() {
    if (this._pollTimer) return;
    if (!this.state.lastPollTime) {
      this.setState({ lastPollTime: new Date().toISOString() });
    }
    this._pollTimer = setInterval(() => this.pollForNewSales(), 30000);
  }

  stopSalePolling() {
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
      this._pollTimer = null;
    }
  }

  pollForNewSales() {
    var self = this;
    var since = this.state.lastPollTime;
    if (!since) return;

    // Also refresh system notifications on each poll
    try {
      var user = Auth.getProfile();
      if (user && user._id) this.fetchProfile(user._id);
    } catch (e) { /* ignore */ }

    // Poll unread message count
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/unread-count')
      .then(data => {
        var newCount = data.unreadCount || 0;
        if (newCount > self.state.unreadMessages) {
          window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'You have new messages', type: 'info' } }));
          self.setState({ messageAnimating: true });
          setTimeout(function() { self.setState({ messageAnimating: false }); }, 500);
        }
        self.setState({ unreadMessages: newCount });
      })
      .catch(() => { /* ignore */ });

    Auth.fetch(constants.DOMAIN + '/api/v1/transactions/poll-sales?since=' + encodeURIComponent(since), {
      mode: 'cors',
      method: 'GET',
    })
      .then(res => {
        if (res.serverTime) {
          self.setState({ lastPollTime: res.serverTime });
        }
        if (res.newSales && res.newSales.length > 0) {
          res.newSales.forEach(function(sale) {
            var title = (sale.post && sale.post.title) || 'an item';
            var payout = Number(sale.sellerPayout) || 0;
            window.dispatchEvent(new CustomEvent('toast', {
              detail: { text: 'You sold ' + title + ' for $' + payout.toFixed(2) + '!', type: 'success' },
            }));
          });
          self.setState({ bellAnimating: true });
          setTimeout(function() { self.setState({ bellAnimating: false }); }, 1000);
          self.fetchNotifications();
        }
      })
      .catch(function() { /* silent — next poll will catch up */ });
  }

  getNotificationItems(includeAll) {
    var items = [];
    var s = this.state;
    var dismissed = s.dismissedNotifs || {};

    // --- Individual sales needing shipment ---
    if (s.sales) {
      s.sales.forEach(function(sale) {
        if (sale.trackingNumber === '' && (sale.paypalCheckoutStatus === 'COMPLETED' || sale.stripeChargeId)) {
          var title = (sale.post && sale.post.title) || 'Item';
          var buyerName = (sale.buyer && sale.buyer.userName) || 'buyer';
          items.push({
            icon: 'fa-truck',
            text: title + ' \u2014 ship to ' + buyerName,
            link: '/orders',
            date: sale.createdAt,
            key: 'sale-' + sale._id,
          });
        }
      });
    }

    // --- Individual purchases awaiting shipment ---
    if (s.purchased) {
      s.purchased.forEach(function(p) {
        if (p.trackingNumber === '' && (p.paypalCheckoutStatus === 'COMPLETED' || p.stripeChargeId)) {
          var title = (p.post && p.post.title) || 'Item';
          var sellerName = (p.seller && p.seller.userName) || 'seller';
          items.push({
            icon: 'fa-clock-o',
            text: title + ' from ' + sellerName + ' \u2014 awaiting shipment',
            link: '/orders',
            date: p.createdAt,
            key: 'purch-await-' + p._id,
          });
        }
        if (p.trackingNumber !== '' && !p.reviewed) {
          var pTitle = (p.post && p.post.title) || 'Item';
          items.push({
            icon: 'fa-star',
            text: pTitle + ' \u2014 leave a review',
            link: '/orders',
            date: p.updatedAt || p.createdAt,
            key: 'purch-review-' + p._id,
          });
        }
      });
    }

    // --- Individual reviews ---
    if (s.reviews) {
      s.reviews.forEach(function(r) {
        if (!r.observedReview) {
          var reviewerName = (r.buyer && r.buyer.userName) || 'Someone';
          items.push({
            icon: 'fa-star-half-o',
            text: reviewerName + ' left a review',
            link: '/orders',
            date: r.createdAt,
            key: 'review-' + r._id,
          });
        }
      });
    }

    // --- New followers (keep count-based, no names available) ---
    if (s.followers && s.observedFollowers !== undefined) {
      var followDiff = s.followers.length - s.observedFollowers;
      if (followDiff > 0) {
        items.push({ icon: 'fa-user-plus', text: followDiff + ' new follower' + (followDiff !== 1 ? 's' : ''), link: '/shop/' + s.username, key: 'followers' });
      }
    }

    // --- Social notifications per post ---
    if (s.socialNotifications) {
      s.socialNotifications.forEach(function(p) {
        var interactions = Number(p.commentNotifications || 0) + Number(p.favoriteNotifications || 0) + Number(p.shareNotifications || 0);
        if (interactions > 0) {
          var postTitle = p.title || 'Your listing';
          items.push({
            icon: 'fa-heart',
            text: postTitle + ' \u2014 ' + interactions + ' new interaction' + (interactions !== 1 ? 's' : ''),
            link: '/orders',
            date: p.updatedAt || p.createdAt,
            key: 'social-' + p._id,
          });
        }
      });
    }

    // --- Reply notifications (keep count-based) ---
    var replyCount = 0;
    if (s.replies) {
      s.replies.forEach(function(r) { replyCount += Number(r.replyNotification || 0); });
    }
    if (replyCount > 0) {
      items.push({ icon: 'fa-comment', text: replyCount + ' new repl' + (replyCount !== 1 ? 'ies' : 'y'), link: '/orders', key: 'replies' });
    }

    // --- Earnings notifications ---
    if (s.marketed && s.marketed.length > 0) {
      var earningsShown = 0;
      s.marketed.forEach(function(m) {
        if (earningsShown >= 3) return;
        var title = (m.post && m.post.title) || 'a listing';
        var amt = Number(m.marketerPayout) || 0;
        if (m.marketerPaid) {
          items.push({
            icon: 'fa-money',
            text: 'You earned $' + amt.toFixed(2) + ' from ' + title,
            link: '/orders',
            date: m.deliveredAt || m.updatedAt || m.createdAt,
            key: 'earn-paid-' + m._id,
          });
          earningsShown++;
        } else if (amt > 0 && m.trackingNumber && m.payoutStatus !== 'refunded' && m.payoutStatus !== 'disputed') {
          items.push({
            icon: 'fa-clock-o',
            text: 'Commission pending: ' + title + ' ($' + amt.toFixed(2) + ')',
            link: '/orders',
            date: m.updatedAt || m.createdAt,
            key: 'earn-pending-' + m._id,
          });
          earningsShown++;
        }
      });
    }

    // --- System / admin notifications (listing removed, etc.) ---
    if (s.systemNotifications) {
      s.systemNotifications.forEach(function(n) {
        var notifIcon = 'fa-exclamation-circle';
        var notifLink = '/orders';
        if (n.type === 'strike' || n.type === 'strike_appeal') {
          notifIcon = n.type === 'strike' ? 'fa-exclamation-triangle' : 'fa-gavel';
          notifLink = '/account-standing';
        } else if (n.type === 'buylist_inventory') {
          notifIcon = 'fa-list';
          notifLink = '/buylist';
        } else if (n.type === 'listing_removed') {
          notifIcon = 'fa-ban';
          notifLink = '/shop/' + s.username;
        } else if (n.type === 'payout') {
          notifIcon = 'fa-usd';
        } else if (n.type === 'dispute') {
          notifIcon = 'fa-flag';
        } else if (n.type === 'order_update') {
          notifIcon = 'fa-truck';
        } else if (n.type === 'system') {
          notifIcon = 'fa-info-circle';
          notifLink = null;
        }
        items.push({
          icon: notifIcon,
          text: n.message,
          link: notifLink,
          date: n.createdAt,
          key: 'sys-' + n._id,
          isSystem: true,
          systemNotifId: n._id,
        });
      });
    }

    // --- Price drop alerts ---
    if (s.priceWatches) {
      s.priceWatches.forEach(function(w) {
        if (w.triggered && !w.dismissed) {
          var cardName = (w.card && w.card.name) || 'A watched card';
          var cardId = w.card && typeof w.card === 'object' ? w.card._id : w.card;
          items.push({
            icon: 'fa-tag',
            text: cardName + ' dropped to $' + (w.triggeredPrice != null ? w.triggeredPrice.toFixed(2) : '??'),
            link: '/card/' + cardId,
            date: w.triggeredAt,
            dismissId: w._id,
            key: 'pw-' + w._id,
          });
        }
      });
    }

    // Sort by date (newest first), items without dates go to end
    items.sort(function(a, b) {
      var da = a.date ? new Date(a.date).getTime() : 0;
      var db = b.date ? new Date(b.date).getTime() : 0;
      return db - da;
    });

    // Filter out dismissed items (unless includeAll is true — used by markAllRead)
    if (!includeAll) {
      items = items.filter(function(item) {
        return !item.key || !dismissed[item.key];
      });
    }

    // When marking all read, return everything so all keys get dismissed
    if (includeAll) return items;
    // Limit to 10 items for display
    return items.slice(0, 10);
  }

  handleSearch(e) {
    e.preventDefault();
    const query = this.state.searchQuery.trim();
    if (query) {
      this.setState({ mobileMenuOpen: false, showSuggestions: false });
      if (this.state.mobileSearchOpen) this.closeMobileSearch();
      this.props.history.push(`/search/${encodeURIComponent(query)}`);
    }
  }

  getActiveTab() {
    var path = this.props.location ? this.props.location.pathname : '';
    if (path === '/') return 'home';
    if (/^\/(browse|search|card)/.test(path)) return 'browse';
    if (/^\/(sell|post)/.test(path)) return 'sell';
    if (/^\/messages/.test(path)) return 'activity';
    if (/^\/orders/.test(path)) return 'orders';
    var u = this.state.username;
    if ((u && path.startsWith('/shop/' + u)) || /^\/(settings|admin)/.test(path)) return 'profile';
    return null;
  }

  render() {
    const { isLoggedIn, searchQuery, profileImage, username, notificationCount, bellAnimating } = this.state;
    const isDark = document.documentElement.classList.contains('tw-dark');
    const searchBorder = this.state.searchFocused ? '#D4A843' : (isDark ? '#333' : '#ccc');
    const currentPath = this.props.location ? this.props.location.pathname : '';

    var showVerificationBanner = isLoggedIn && !this.state.verified && !this.state.verificationBannerDismissed;

    return (
      <GameContext.Consumer>
      {(gameCtx) => {
        this._gameCtx = gameCtx;
        return (
      <React.Fragment>
      <nav className="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-50" style={{ backgroundColor: isDark ? 'rgba(26,26,26,0.92)' : 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', boxShadow: isDark ? '0 1px 0 rgba(255,255,255,0.06)' : '0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03)', borderBottom: '1px solid ' + (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)') }}>
        <div className="tw-max-w-6xl tw-mx-auto tw-px-4 tw-h-16 tw-flex tw-items-center tw-justify-between">
          {/* Logo */}
          <div className="tw-flex tw-flex-col tw-flex-shrink-0">
            <Link to="/" className="tw-flex tw-items-center tw-gap-2 tw-no-underline">
              <img src={isDark ? logoDark : logoLight} alt="Primal Market" className="tw-h-10 tw-w-auto" />
              <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: '20px', fontWeight: 800, letterSpacing: '-0.3px', lineHeight: '1', color: isDark ? '#c9a84c' : '#1a1a1a' }}>
                PrimalMarket
              </span>
            </Link>
          </div>

          {/* Desktop: Search bar */}
          <div ref={this.searchRef} className="tw-hidden md:tw-flex tw-flex-1 tw-max-w-md tw-mx-6 tw-relative">
            <form onSubmit={this.handleSearch} className="tw-w-full">
              <div
                className="tw-flex tw-items-center tw-w-full tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f]"
                style={{ border: '1px solid ' + searchBorder, borderRadius: '8px', height: '42px', transition: 'border-color 200ms ease, box-shadow 200ms ease', boxShadow: this.state.searchFocused ? '0 0 0 3px rgba(212,168,67,0.15)' : 'none' }}
              >
                <span className="tw-text-sm" style={{ paddingLeft: '12px', color: this.state.searchFocused ? '#D4A843' : '#9ca3af', transition: 'color 200ms ease' }}>
                  <i className="fa fa-search" />
                </span>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={this.handleSearchInput}
                  onFocus={() => { this.setState({ searchFocused: true }); if (this.state.suggestions.length > 0) this.setState({ showSuggestions: true }); }}
                  onBlur={() => this.setState({ searchFocused: false })}
                  placeholder="Search for cards"
                  className="tw-flex-1 tw-bg-transparent tw-text-[#1a1a1a] dark:tw-text-white tw-text-sm tw-outline-none tw-placeholder-gray-500"
                  style={{ border: 'none', padding: '0 10px', height: '100%', boxShadow: 'none' }}
                  autoComplete="off"
                />
                <button type="submit" style={{ display: 'none' }} />
              </div>
            </form>
            {this.state.showSuggestions && this.state.suggestions.length > 0 && (
              <div className="tw-absolute tw-top-full tw-left-0 tw-right-0 tw-mt-1 tw-bg-white dark:tw-bg-[#1a1a1a] tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] tw-rounded-lg tw-shadow-xl tw-overflow-hidden tw-z-50 dropdown-enter-center" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {this.state.suggestions.map(card => {
                  var imgUrl = resolveCardImage(card.image);
                  return (
                    <div
                      key={card._id}
                      onClick={() => this.handleSuggestionClick(card._id)}
                      className="tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#252525] tw-transition-colors tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#252525] last:tw-border-b-0"
                    >
                      <div className="tw-w-10 tw-h-14 tw-rounded tw-overflow-hidden tw-bg-[#e0e0e0] dark:tw-bg-[#252525] tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center">
                        {imgUrl ? (
                          <img src={imgUrl} alt={card.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <i className="fa fa-image tw-text-[#ccc] dark:tw-text-[#555] tw-text-xs"></i>
                        )}
                      </div>
                      <div className="tw-flex-1 tw-min-w-0">
                        <p className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0 tw-truncate">{card.name}</p>
                        <p className="tw-text-[10px] tw-text-[#999] dark:tw-text-[#666] tw-mb-0">{card.cardSet}</p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
                        {renderRarityBadge(card.rarity, null)}
                        {card.lowestPrice != null ? (
                          <span className="tw-text-sm tw-font-bold tw-text-brand-gold">${card.lowestPrice.toFixed(2)}</span>
                        ) : (
                          <span className="tw-text-[11px] tw-font-semibold tw-text-[#777]">No listings</span>
                        )}
                      </div>
                    </div>
                  );
                })}
                <div
                  onClick={() => { this.setState({ showSuggestions: false }); this.props.history.push('/search/' + encodeURIComponent(searchQuery.trim())); }}
                  className="tw-text-center tw-py-2.5 tw-text-sm tw-font-medium tw-text-brand-gold tw-cursor-pointer hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#252525] tw-transition-colors tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#333]"
                >
                  See all results for "{searchQuery.trim()}"
                </div>
              </div>
            )}
          </div>

          {/* Desktop: Right nav items */}
          <div className="tw-hidden md:tw-flex tw-items-center tw-gap-4">
            <Link to="/browse" className="tw-no-underline tw-text-sm tw-font-medium tw-relative tw-py-1" style={{ color: currentPath.startsWith('/browse') ? '#c9a84c' : (isDark ? '#d1d5db' : '#666'), textDecoration: 'none', transition: 'color 0.15s ease' }} onMouseEnter={function(e) { if (!currentPath.startsWith('/browse')) e.currentTarget.style.color = '#c9a84c'; }} onMouseLeave={function(e) { if (!currentPath.startsWith('/browse')) e.currentTarget.style.color = isDark ? '#d1d5db' : '#666'; }}>
              Browse
              {currentPath.startsWith('/browse') && <span style={{ position: 'absolute', bottom: '-4px', left: '50%', transform: 'translateX(-50%)', width: '16px', height: '2px', borderRadius: '1px', backgroundColor: '#D4A843' }} />}
            </Link>
            {isLoggedIn ? (
              <>
                <Link to="/sell" className="tw-no-underline tw-text-sm tw-font-semibold tw-relative tw-py-1" style={{ color: '#c9a84c', textDecoration: 'none', transition: 'color 0.15s ease' }} onMouseEnter={function(e) { e.currentTarget.style.color = '#b8953f'; }} onMouseLeave={function(e) { e.currentTarget.style.color = '#c9a84c'; }}>
                  Sell
                  {currentPath === '/sell' && <span style={{ position: 'absolute', bottom: '-4px', left: '50%', transform: 'translateX(-50%)', width: '16px', height: '2px', borderRadius: '1px', backgroundColor: '#D4A843' }} />}
                </Link>
                <CartContext.Consumer>
                  {({ cartCount }) => (
                    <Link to="/cart" className={'tw-relative tw-no-underline tw-transition-all tw-flex tw-items-center tw-justify-center' + (this.state.cartAnimating ? ' badge-pop' : '') + (currentPath === '/cart' ? '' : ' tw-text-[#666] dark:tw-text-gray-300 hover:tw-text-brand-gold')} title="Cart" style={{ width: '36px', height: '36px', borderRadius: '50%', transition: 'background-color 200ms ease, color 200ms ease', color: currentPath === '/cart' ? '#c9a84c' : undefined }} onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)'; e.currentTarget.style.color = '#c9a84c'; }} onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; if (currentPath !== '/cart') e.currentTarget.style.color = ''; }}>
                      <i className="fa fa-shopping-cart" style={{ fontSize: '1.1em' }} />
                      {cartCount > 0 && (
                        <span className={'tw-absolute tw-bg-brand-gold tw-text-black tw-text-xs tw-rounded-full tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center tw-font-bold' + (this.state.cartAnimating ? ' badge-pop' : '')} style={{ fontSize: '10px', top: '2px', right: '0px' }}>
                          {cartCount > 9 ? '9+' : cartCount}
                        </span>
                      )}
                    </Link>
                  )}
                </CartContext.Consumer>

                {/* Messages Icon */}
                <Link
                  to="/messages"
                  className={'tw-relative tw-no-underline tw-transition-all tw-flex tw-items-center tw-justify-center' + (this.state.messageAnimating ? ' badge-pop' : '') + (currentPath.startsWith('/messages') ? '' : ' tw-text-[#666] dark:tw-text-gray-300 hover:tw-text-brand-gold')}
                  style={{ width: '36px', height: '36px', borderRadius: '50%', transition: 'background-color 200ms ease, color 200ms ease', color: currentPath.startsWith('/messages') ? '#c9a84c' : undefined }}
                  onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)'; e.currentTarget.style.color = '#c9a84c'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; if (!currentPath.startsWith('/messages')) e.currentTarget.style.color = ''; }}
                >
                  <i className={'fa ' + (this.state.unreadMessages > 0 ? 'fa-envelope' : 'fa-envelope-o')} style={{ fontSize: '1.05em' }} />
                  {this.state.unreadMessages > 0 && (
                    <span className={'tw-absolute tw-bg-brand-gold tw-text-black tw-text-xs tw-rounded-full tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center tw-font-bold' + (this.state.messageAnimating ? ' badge-pop' : '')} style={{ fontSize: '10px', top: '2px', right: '0px' }}>
                      {this.state.unreadMessages > 9 ? '9+' : this.state.unreadMessages}
                    </span>
                  )}
                </Link>

                {/* Notification Dropdown */}
                <div ref={this.notifDropdownRef} className="tw-relative">
                  <button
                    onClick={() => this.setState(prev => ({ notifDropdownOpen: !prev.notifDropdownOpen, profileDropdownOpen: false }))}
                    className="tw-relative tw-bg-transparent tw-border-0 tw-cursor-pointer tw-transition-all tw-flex tw-items-center tw-justify-center tw-text-[#666] dark:tw-text-gray-300 hover:tw-text-brand-gold"
                    style={{ width: '36px', height: '36px', borderRadius: '50%', padding: 0, transition: 'background-color 200ms ease, color 200ms ease' }}
                    onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)'; }}
                    onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    <i className={'fa fa-bell-o' + (bellAnimating ? ' bell-ring' : '')} style={{ fontSize: '1.1em' }} />
                    {notificationCount > 0 && (
                      <span className={'tw-absolute tw-bg-brand-gold tw-text-black tw-text-xs tw-rounded-full tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center tw-font-bold' + (bellAnimating ? ' badge-pop' : '')} style={{ fontSize: '10px', top: '2px', right: '0px' }}>
                        {notificationCount > 9 ? '9+' : notificationCount}
                      </span>
                    )}
                  </button>
                  {this.state.notifDropdownOpen && (
                    <div className="tw-absolute tw-right-0 tw-top-full tw-mt-2 tw-w-72 tw-z-50 dropdown-enter">
                      <div className="tw-absolute tw-bg-white dark:tw-bg-[#1a1a1a] tw-border-l tw-border-t tw-border-[#e0e0e0] dark:tw-border-[#333]" style={{ top: '-5px', right: '14px', width: '10px', height: '10px', transform: 'rotate(45deg)', zIndex: 1 }} />
                      <div className="tw-bg-white dark:tw-bg-[#1a1a1a] tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] tw-rounded-xl tw-shadow-xl tw-overflow-hidden">
                      <div className="tw-px-4 tw-py-3 tw-border-b tw-border-[#e0e0e0] dark:tw-border-[#333] tw-flex tw-items-center tw-justify-between">
                        <p className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-0">Notifications</p>
                        {notificationCount > 0 && (
                          <button
                            onClick={() => this.markAllRead()}
                            className="tw-text-xs tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0 tw-transition-colors"
                          >
                            Mark all read
                          </button>
                        )}
                      </div>
                      {(() => {
                        var notifItems = this.getNotificationItems();
                        if (notifItems.length === 0) {
                          return (
                            <div className="tw-text-center tw-py-8">
                              <i className="fa fa-bell-o tw-text-2xl tw-text-[#ccc] dark:tw-text-[#555] tw-mb-2" style={{ display: 'block' }} />
                              <p className="tw-text-sm tw-text-[#999] dark:tw-text-gray-500 tw-mb-0">No new notifications</p>
                            </div>
                          );
                        }
                        return (
                          <div className="tw-max-h-80 tw-overflow-y-auto">
                            {notifItems.map((item, idx) => (
                              <div
                                key={item.key || idx}
                                className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-2.5 hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#252525] tw-transition-colors tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#252525] last:tw-border-b-0"
                                style={item.isSystem ? { backgroundColor: 'rgba(239, 68, 68, 0.06)' } : undefined}
                              >
                                <Link
                                  to={item.link}
                                  onClick={() => {
                                    this.setState({ notifDropdownOpen: false });
                                    if (item.systemNotifId) this.dismissSystemNotification(item.systemNotifId, item.key);
                                    else {
                                      if (item.dismissId) this.dismissPriceWatch(item.dismissId);
                                      if (item.key) this.dismissNotif(item.key);
                                    }
                                  }}
                                  className="tw-flex tw-items-center tw-gap-3 tw-flex-1 tw-min-w-0 tw-no-underline"
                                >
                                  <i className={'fa ' + item.icon + ' tw-w-4 tw-text-center tw-flex-shrink-0'} style={{ color: item.isSystem ? '#ef4444' : '#D4A843' }} />
                                  <span className={'tw-text-sm tw-leading-snug' + (item.isSystem ? '' : ' tw-text-[#1a1a1a] dark:tw-text-white')} style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', color: item.isSystem ? '#ef4444' : undefined }}>{item.text}</span>
                                </Link>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (item.systemNotifId) this.dismissSystemNotification(item.systemNotifId, item.key);
                                    else {
                                      if (item.dismissId) this.dismissPriceWatch(item.dismissId);
                                      if (item.key) this.dismissNotif(item.key);
                                    }
                                  }}
                                  className="tw-text-[#ccc] dark:tw-text-[#555] hover:tw-text-[#999] tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0 tw-flex-shrink-0"
                                  title="Dismiss"
                                >
                                  <i className="fa fa-times tw-text-xs" />
                                </button>
                              </div>
                            ))}
                          </div>
                        );
                      })()}
                      <Link
                        to="/orders"
                        onClick={() => this.setState({ notifDropdownOpen: false })}
                        className="tw-block tw-text-center tw-py-2.5 tw-text-xs tw-font-medium tw-no-underline tw-transition-colors"
                        style={{ color: '#c9a84c', borderTop: '1px solid ' + (isDark ? '#333' : '#e0e0e0') }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; e.currentTarget.style.color = '#c9a84c'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      >
                        View All Orders
                      </Link>
                      </div>
                    </div>
                  )}
                </div>

                {/* Profile Dropdown */}
                <div ref={this.profileDropdownRef} className="tw-relative">
                  <button
                    onClick={() => this.setState(prev => ({ profileDropdownOpen: !prev.profileDropdownOpen, notifDropdownOpen: false }))}
                    className="tw-flex tw-items-center tw-bg-transparent tw-border-0 tw-cursor-pointer"
                    style={{ padding: '2px', borderRadius: '50%', background: this.state.profileDropdownOpen ? 'linear-gradient(135deg, #D4A843, #b8953f)' : 'transparent', transition: 'all 200ms ease' }}
                    onMouseEnter={function(e) { if (!this.state.profileDropdownOpen) e.currentTarget.style.background = 'linear-gradient(135deg, rgba(212,168,67,0.4), rgba(184,149,63,0.4))'; }.bind(this)}
                    onMouseLeave={function(e) { if (!this.state.profileDropdownOpen) e.currentTarget.style.background = 'transparent'; }.bind(this)}
                  >
                    {profileImage ? (
                      <img src={profileImage} alt="Profile" className="tw-w-8 tw-h-8 tw-rounded-full tw-object-cover" style={{ border: '2px solid ' + (isDark ? '#1a1a1a' : '#fff') }} />
                    ) : (
                      <div className="tw-w-8 tw-h-8 tw-rounded-full tw-bg-[#333]" style={{ border: '2px solid ' + (isDark ? '#1a1a1a' : '#fff') }} />
                    )}
                  </button>
                  {this.state.profileDropdownOpen && (
                    <div className="tw-absolute tw-right-0 tw-top-full tw-mt-2 tw-w-48 tw-z-50 dropdown-enter">
                      <div className="tw-absolute" style={{ top: '-5px', right: '10px', width: '10px', height: '10px', transform: 'rotate(45deg)', zIndex: 1, backgroundColor: isDark ? '#1a1a1a' : '#fff', borderLeft: '1px solid ' + (isDark ? '#333' : '#e0e0e0'), borderTop: '1px solid ' + (isDark ? '#333' : '#e0e0e0') }} />
                      <div className="tw-rounded-xl tw-shadow-xl tw-overflow-hidden tw-py-1" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#e0e0e0') }}>
                      <div className="tw-px-4 tw-py-2" style={{ borderBottom: '1px solid ' + (isDark ? '#333' : '#e0e0e0') }}>
                        <span className="tw-text-xs tw-font-bold" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{username}</span>
                      </div>
                      <Link
                        to={'/shop/' + username}
                        onClick={() => this.setState({ profileDropdownOpen: false })}
                        className="tw-flex tw-items-center tw-gap-2.5 tw-px-4 tw-py-2.5 tw-text-sm tw-no-underline"
                        style={{ color: isDark ? '#fff' : '#1a1a1a', transition: 'background-color 0.15s ease' }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      >
                        <i className="fa fa-home tw-w-4 tw-text-center" style={{ color: '#999' }} />
                        My Shop
                      </Link>
                      <Link
                        to="/orders"
                        onClick={() => this.setState({ profileDropdownOpen: false })}
                        className="tw-flex tw-items-center tw-gap-2.5 tw-px-4 tw-py-2.5 tw-text-sm tw-no-underline"
                        style={{ color: isDark ? '#fff' : '#1a1a1a', transition: 'background-color 0.15s ease' }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      >
                        <i className="fa fa-shopping-bag tw-w-4 tw-text-center" style={{ color: '#999' }} />
                        Orders
                      </Link>
                      {/* BUYLIST FEATURE: disabled — preserved for future use */}
                      <Link
                        to="/settings"
                        onClick={() => this.setState({ profileDropdownOpen: false })}
                        className="tw-flex tw-items-center tw-gap-2.5 tw-px-4 tw-py-2.5 tw-text-sm tw-no-underline"
                        style={{ color: isDark ? '#fff' : '#1a1a1a', transition: 'background-color 0.15s ease' }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      >
                        <i className="fa fa-cog tw-w-4 tw-text-center" style={{ color: '#999' }} />
                        Settings
                      </Link>
                      {this.state.userRole === 'admin' && (
                        <Link
                          to="/admin"
                          onClick={() => this.setState({ profileDropdownOpen: false })}
                          className="tw-flex tw-items-center tw-gap-2.5 tw-px-4 tw-py-2.5 tw-text-sm tw-no-underline"
                          style={{ color: '#D4A843', transition: 'background-color 0.15s ease' }}
                          onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; }}
                          onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <i className="fa fa-shield tw-w-4 tw-text-center" />
                          Admin
                        </Link>
                      )}
                      {this.state.userRole === 'admin' && (
                        <Link
                          to="/admin/analytics"
                          onClick={() => this.setState({ profileDropdownOpen: false })}
                          className="tw-flex tw-items-center tw-gap-2.5 tw-px-4 tw-py-2.5 tw-text-sm tw-no-underline"
                          style={{ color: '#D4A843', transition: 'background-color 0.15s ease' }}
                          onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; }}
                          onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          <i className="fa fa-bar-chart tw-w-4 tw-text-center" />
                          Analytics
                        </Link>
                      )}
                      <ThemeToggle />
                      <div style={{ borderTop: '1px solid ' + (isDark ? '#333' : '#e0e0e0') }} />
                      <button
                        onClick={() => { this.setState({ profileDropdownOpen: false }); this.handleLogout(); }}
                        className="tw-flex tw-items-center tw-gap-2.5 tw-px-4 tw-py-2.5 tw-text-sm tw-bg-transparent tw-border-0 tw-cursor-pointer tw-w-full tw-text-left"
                        style={{ color: '#ef4444', transition: 'background-color 0.15s ease' }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      >
                        <i className="fa fa-sign-out tw-w-4 tw-text-center" />
                        Log Out
                      </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <ThemeToggle compact />
                <button
                  onClick={() => this.context.openAuthModal('login')}
                  className="tw-text-[#666] dark:tw-text-gray-300 hover:tw-text-[#1a1a1a] dark:hover:tw-text-white tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-sm tw-transition-colors tw-p-0"
                >
                  Login
                </button>
                <button
                  onClick={() => this.context.openAuthModal('signup')}
                  className="tw-bg-brand-gold hover:tw-bg-brand-gold-dark tw-text-black tw-text-sm tw-font-semibold tw-px-4 tw-py-1.5 tw-rounded-lg tw-border-0 tw-cursor-pointer"
                  style={{ transition: 'all 200ms ease', boxShadow: '0 2px 8px rgba(212,168,67,0.25)' }}
                  onMouseEnter={function(e) { e.currentTarget.style.boxShadow = '0 4px 16px rgba(212,168,67,0.35)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.boxShadow = '0 2px 8px rgba(212,168,67,0.25)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  Sign Up
                </button>
              </>
            )}
          </div>

          {/* Mobile: Theme toggle (logged-out only — logged-in users access it from the "You" sheet) */}
          {!isLoggedIn && (
            <span className="md:tw-hidden">
              <ThemeToggle compact />
            </span>
          )}

          {/* Mobile: Search icon */}
          <button
            onClick={this.openMobileSearch}
            className="md:tw-hidden tw-bg-transparent tw-border-none tw-text-[#666] dark:tw-text-gray-300 tw-text-xl tw-cursor-pointer tw-p-2"
            aria-label="Search"
          >
            <i className="fa fa-search" />
          </button>

          {/* Mobile: Cart icon */}
          <CartContext.Consumer>
            {({ cartCount }) => (
              <button
                onClick={this.openMobileCart}
                className="md:tw-hidden tw-relative tw-bg-transparent tw-border-none tw-text-xl tw-p-2 tw-cursor-pointer tw-leading-none"
                style={{ color: isDark ? '#d1d5db' : '#666', lineHeight: 1 }}
                aria-label="Cart"
              >
                <i className="fa fa-shopping-cart" />
                {cartCount > 0 && (
                  <span
                    className={'tw-absolute tw-flex tw-items-center tw-justify-center tw-rounded-full tw-font-bold' + (this.state.cartAnimating ? ' badge-pop' : '')}
                    style={{ top: '2px', right: '0', width: '16px', height: '16px', fontSize: '9px', backgroundColor: '#c9a84c', color: '#000' }}
                  >
                    {cartCount > 9 ? '9+' : cartCount}
                  </span>
                )}
              </button>
            )}
          </CartContext.Consumer>

        </div>

        {showVerificationBanner && (
          <div
            className="tw-absolute tw-left-0 tw-right-0 tw-text-center tw-py-2 tw-px-4 tw-text-sm"
            style={{ top: '100%', backgroundColor: '#d4a843', color: '#000', zIndex: 10 }}
          >
            Please verify your email. Check your inbox or{' '}
            <button
              onClick={() => this.handleResendVerification()}
              disabled={this.state.resendingVerification}
              className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-font-bold tw-p-0 tw-text-sm tw-underline"
              style={{ color: '#000' }}
            >
              {this.state.resendingVerification ? 'sending...' : 'resend verification email'}
            </button>
            .
            <button
              onClick={() => { sessionStorage.setItem('primal_verify_dismissed', 'true'); this.setState({ verificationBannerDismissed: true }); }}
              className="tw-absolute tw-right-3 tw-top-1/2 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-sm tw-p-1"
              style={{ color: '#000', transform: 'translateY(-50%)' }}
              aria-label="Dismiss"
            >
              <i className="fa fa-times" />
            </button>
          </div>
        )}
        {this.state.announcement && !this.state.announcementDismissed && (
          <div
            className="tw-absolute tw-left-0 tw-right-0 tw-text-center tw-py-2.5 tw-px-8 tw-text-sm tw-font-semibold tw-text-white"
            style={{
              top: showVerificationBanner ? 'calc(100% + 36px)' : '100%',
              background: this.state.announcement.type === 'error'
                ? 'linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #dc2626 100%)'
                : this.state.announcement.type === 'warning'
                ? 'linear-gradient(135deg, #d97706 0%, #f59e0b 50%, #d97706 100%)'
                : this.state.announcement.type === 'success'
                ? 'linear-gradient(135deg, #059669 0%, #10B981 50%, #059669 100%)'
                : 'linear-gradient(135deg, #2563eb 0%, #3B82F6 50%, #2563eb 100%)',
              zIndex: 10,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              letterSpacing: '0.02em',
            }}
          >
            <i className={'fa tw-mr-2 ' + (this.state.announcement.type === 'error' ? 'fa-exclamation-circle' : this.state.announcement.type === 'warning' ? 'fa-warning' : this.state.announcement.type === 'success' ? 'fa-check-circle' : 'fa-info-circle')} style={{ fontSize: '13px' }} />
            {this.state.announcement.text}
            <button
              onClick={function() { this.setState({ announcementDismissed: true }); }.bind(this)}
              className="tw-absolute tw-right-4 tw-top-1/2 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-white tw-p-1 tw-rounded-full"
              style={{ transform: 'translateY(-50%)', opacity: 0.7, transition: 'opacity 0.15s' }}
              onMouseEnter={function(e) { e.currentTarget.style.opacity = '1'; }}
              onMouseLeave={function(e) { e.currentTarget.style.opacity = '0.7'; }}
              aria-label="Dismiss announcement"
            >
              <i className="fa fa-times" style={{ fontSize: '12px' }} />
            </button>
          </div>
        )}
      </nav>
      {showVerificationBanner && (
        <div style={{ height: '36px' }} />
      )}
      {this.state.announcement && !this.state.announcementDismissed && (
        <div style={{ height: '40px' }} />
      )}

      {/* Full-screen mobile search overlay */}
      {(this.state.mobileSearchOpen || this.state.mobileSearchClosing) && (() => {
        var closingSearch = this.state.mobileSearchClosing;
        return (
          <div className="md:tw-hidden" style={{ position: 'fixed', inset: 0, zIndex: 55, touchAction: 'none' }}>
            {/* Backdrop */}
            <div
              className={closingSearch ? 'sheet-backdrop-closing' : 'sheet-backdrop'}
              onClick={this.closeMobileSearch}
              onTouchMove={function(e) { e.preventDefault(); }}
              style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.35)', backdropFilter: 'saturate(180%) blur(20px)', WebkitBackdropFilter: 'saturate(180%) blur(20px)', touchAction: 'none' }}
            />
            {/* Panel */}
            <div
              ref={this.mobileSearchRef}
              className={closingSearch ? 'overlay-panel-closing' : 'overlay-panel'}
              style={{
                position: 'absolute', top: 0, left: 0, right: 0,
                maxHeight: '100vh', overflowY: 'auto', WebkitOverflowScrolling: 'touch',
                backgroundColor: isDark ? 'rgba(26,26,26,0.97)' : 'rgba(255,255,255,0.97)',
                backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
                paddingTop: '64px', paddingBottom: '24px',
                boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
              }}
            >
              {/* Close button */}
              <button
                onClick={this.closeMobileSearch}
                style={{
                  position: 'absolute', top: '16px', right: '16px',
                  background: 'none', border: 'none', cursor: 'pointer',
                  width: '32px', height: '32px', borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: isDark ? '#999' : '#666',
                  backgroundColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)',
                }}
                aria-label="Close search"
              >
                <i className="fa fa-times" style={{ fontSize: '16px' }} />
              </button>

              {/* Search input */}
              <div style={{ padding: '0 20px' }}>
                <form onSubmit={this.handleSearch}>
                  <div
                    style={{
                      display: 'flex', alignItems: 'center',
                      backgroundColor: isDark ? '#0f0f0f' : '#f5f5f5',
                      border: '1px solid ' + (isDark ? '#333' : '#ccc'),
                      borderRadius: '12px', height: '48px',
                    }}
                  >
                    <span style={{ paddingLeft: '14px', color: '#9ca3af', fontSize: '14px' }}>
                      <i className="fa fa-search" />
                    </span>
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={this.handleSearchInput}
                      placeholder="Search for cards"
                      autoFocus
                      autoComplete="off"
                      className="tw-text-[#1a1a1a] dark:tw-text-white"
                      style={{
                        flex: 1, background: 'transparent', border: 'none',
                        padding: '0 12px', height: '100%', fontSize: '16px',
                        outline: 'none', boxShadow: 'none',
                      }}
                    />
                    {searchQuery && (
                      <button
                        type="button"
                        onClick={function() { this.setState({ searchQuery: '', suggestions: [], showSuggestions: false }); }.bind(this)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 14px', color: isDark ? '#666' : '#999' }}
                      >
                        <i className="fa fa-times-circle" />
                      </button>
                    )}
                    <button type="submit" style={{ display: 'none' }} />
                  </div>
                </form>
              </div>

              {/* Suggestions */}
              {this.state.suggestionsLoading && (
                <div style={{ textAlign: 'center', padding: '24px 0' }}>
                  <i className="fa fa-spinner fa-spin" style={{ fontSize: '20px', color: '#c9a84c' }} />
                </div>
              )}

              {!this.state.suggestionsLoading && this.state.suggestions.length > 0 && (
                <div style={{ marginTop: '8px' }}>
                  <div style={{ padding: '8px 20px 4px', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: isDark ? '#aaa' : '#999' }}>
                    Results
                  </div>
                  {this.state.suggestions.map(function(card) {
                    var imgUrl = resolveCardImage(card.image);
                    return (
                      <div
                        key={card._id}
                        onClick={function() { this.handleSuggestionClick(card._id); }.bind(this)}
                        style={{
                          display: 'flex', alignItems: 'center', gap: '12px',
                          padding: '10px 20px', cursor: 'pointer',
                          transition: 'background-color 0.15s ease',
                        }}
                      >
                        <div style={{
                          width: '40px', height: '56px', borderRadius: '6px', overflow: 'hidden', flexShrink: 0,
                          backgroundColor: isDark ? '#252525' : '#e0e0e0',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          {imgUrl ? (
                            <img src={imgUrl} alt={card.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          ) : (
                            <i className="fa fa-image" style={{ color: isDark ? '#555' : '#ccc', fontSize: '12px' }} />
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: '14px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{card.name}</div>
                          <div style={{ fontSize: '11px', color: isDark ? '#999' : '#999', marginTop: '1px' }}>{card.cardSet}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                          {renderRarityBadge(card.rarity, null)}
                          {card.lowestPrice != null ? (
                            <span style={{ fontSize: '14px', fontWeight: '700', color: '#c9a84c' }}>${card.lowestPrice.toFixed(2)}</span>
                          ) : (
                            <span style={{ fontSize: '11px', fontWeight: '600', color: '#777' }}>No listings</span>
                          )}
                          <i className="fa fa-chevron-right" style={{ fontSize: '10px', color: isDark ? '#555' : '#ccc' }} />
                        </div>
                      </div>
                    );
                  }.bind(this))}
                  {/* See all results */}
                  <div
                    onClick={function() { this.closeMobileSearch(); this.props.history.push('/search/' + encodeURIComponent(searchQuery.trim())); }.bind(this)}
                    style={{
                      textAlign: 'center', padding: '12px 20px', fontSize: '14px', fontWeight: '600',
                      color: '#c9a84c', cursor: 'pointer',
                      borderTop: '1px solid ' + (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'),
                    }}
                  >
                    See all results for &ldquo;{searchQuery.trim()}&rdquo;
                  </div>
                </div>
              )}

              {/* Quick Links — shown when no query */}
              {!searchQuery.trim() && !this.state.suggestionsLoading && (
                <div style={{ marginTop: '16px' }}>
                  <div style={{ padding: '8px 20px 4px', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: isDark ? '#aaa' : '#999' }}>
                    Quick Links
                  </div>
                  <div
                    onClick={function() { this.closeMobileSearch(); this.props.history.push('/browse'); }.bind(this)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '12px',
                      padding: '12px 20px', cursor: 'pointer',
                    }}
                  >
                    <div style={{
                      width: '36px', height: '36px', borderRadius: '10px',
                      backgroundColor: isDark ? 'rgba(201,168,76,0.15)' : 'rgba(201,168,76,0.1)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <i className="fa fa-compass" style={{ fontSize: '16px', color: '#c9a84c' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>Browse All Cards</div>
                      <div style={{ fontSize: '11px', color: isDark ? '#999' : '#888', marginTop: '1px' }}>Explore the full catalog</div>
                    </div>
                    <i className="fa fa-chevron-right" style={{ fontSize: '10px', color: isDark ? '#777' : '#ccc' }} />
                  </div>
                  <div
                    onClick={function() { this.closeMobileSearch(); this.props.history.push('/listings'); }.bind(this)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '12px',
                      padding: '12px 20px', cursor: 'pointer',
                    }}
                  >
                    <div style={{
                      width: '36px', height: '36px', borderRadius: '10px',
                      backgroundColor: isDark ? 'rgba(201,168,76,0.15)' : 'rgba(201,168,76,0.1)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <i className="fa fa-clock-o" style={{ fontSize: '16px', color: '#c9a84c' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a' }}>Newest Listings</div>
                      <div style={{ fontSize: '11px', color: isDark ? '#999' : '#888', marginTop: '1px' }}>Recently added cards</div>
                    </div>
                    <i className="fa fa-chevron-right" style={{ fontSize: '10px', color: isDark ? '#777' : '#ccc' }} />
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Full-screen mobile cart overlay */}
      {(this.state.mobileCartOpen || this.state.mobileCartClosing) && (() => {
        var closingCart = this.state.mobileCartClosing;
        return (
          <CartContext.Consumer>
          {({ cart, cartCount, removeFromCart }) => (
          <div className="md:tw-hidden" style={{ position: 'fixed', inset: 0, zIndex: 55, touchAction: 'none' }}>
            {/* Backdrop */}
            <div
              className={closingCart ? 'sheet-backdrop-closing' : 'sheet-backdrop'}
              onClick={this.closeMobileCart}
              onTouchMove={function(e) { e.preventDefault(); }}
              style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.35)', backdropFilter: 'saturate(180%) blur(20px)', WebkitBackdropFilter: 'saturate(180%) blur(20px)', touchAction: 'none' }}
            />
            {/* Panel */}
            <div
              ref={this.mobileCartRef}
              className={closingCart ? 'overlay-panel-closing' : 'overlay-panel'}
              style={{
                position: 'absolute', top: 0, left: 0, right: 0,
                maxHeight: '100vh', overflowY: 'auto', WebkitOverflowScrolling: 'touch',
                backgroundColor: isDark ? 'rgba(26,26,26,0.97)' : 'rgba(255,255,255,0.97)',
                backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
                paddingTop: '64px', paddingBottom: '24px',
                boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
              }}
            >
              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px 12px' }}>
                <h2 style={{ fontSize: '20px', fontWeight: '700', color: isDark ? '#fff' : '#1a1a1a', margin: 0 }}>
                  Shopping Cart
                  {cartCount > 0 && (
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      minWidth: '22px', height: '22px', borderRadius: '11px',
                      backgroundColor: '#c9a84c', color: '#000',
                      fontSize: '11px', fontWeight: '700', marginLeft: '8px', padding: '0 6px',
                      verticalAlign: 'middle', position: 'relative', top: '-1px',
                    }}>
                      {cartCount}
                    </span>
                  )}
                </h2>
                <button
                  onClick={this.closeMobileCart}
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    width: '32px', height: '32px', borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: isDark ? '#999' : '#666',
                    backgroundColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)',
                  }}
                  aria-label="Close cart"
                >
                  <i className="fa fa-times" style={{ fontSize: '16px' }} />
                </button>
              </div>

              {/* Empty state */}
              {cartCount === 0 && (
                <div style={{ textAlign: 'center', padding: '48px 20px' }}>
                  <i className="fa fa-shopping-cart" style={{ fontSize: '48px', color: isDark ? '#444' : '#ddd', display: 'block', marginBottom: '16px' }} />
                  <p style={{ fontSize: '16px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a', margin: '0 0 4px' }}>Your cart is empty</p>
                  <p style={{ fontSize: '13px', color: isDark ? '#999' : '#888', margin: '0 0 20px' }}>Find cards to add to your cart</p>
                  <button
                    onClick={function() { this.closeMobileCart(); this.props.history.push('/browse'); }.bind(this)}
                    style={{
                      backgroundColor: '#c9a84c', color: '#000',
                      border: 'none', borderRadius: '12px', cursor: 'pointer',
                      padding: '12px 28px', fontSize: '14px', fontWeight: '700',
                    }}
                  >
                    Browse Cards
                  </button>
                </div>
              )}

              {/* Cart items */}
              {cartCount > 0 && (
                <div>
                  <div style={{ padding: '0 20px' }}>
                    {cart.map(function(item) {
                      var itemImage = resolveCardImage(item.cardImage) || resolveCardImage(item.image) || (item.image && item.image.indexOf('http') === 0 ? item.image : null);
                      var lineTotal = (Number(item.price) || 0) * (item.quantity || 1);
                      return (
                        <div key={item.postId} style={{
                          display: 'flex', alignItems: 'center', gap: '12px',
                          padding: '12px 0',
                          borderBottom: '1px solid ' + (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'),
                        }}>
                          <div style={{
                            width: '48px', height: '64px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0,
                            backgroundColor: isDark ? '#252525' : '#e0e0e0',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                          }}>
                            {itemImage ? (
                              <img src={itemImage} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            ) : (
                              <i className="fa fa-image" style={{ color: isDark ? '#555' : '#ccc', fontSize: '14px' }} />
                            )}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: '13px', fontWeight: '600', color: isDark ? '#fff' : '#1a1a1a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {item.title}
                            </div>
                            <div style={{ fontSize: '11px', color: isDark ? '#999' : '#888', marginTop: '2px' }}>
                              {item.quantity > 1 ? item.quantity + ' × ' : ''}${(Number(item.price) || 0).toFixed(2)}
                              {item.condition ? ' · ' + item.condition : ''}
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
                            <span style={{ fontSize: '14px', fontWeight: '700', color: '#c9a84c' }}>
                              ${lineTotal.toFixed(2)}
                            </span>
                            <button
                              onClick={function() { removeFromCart(item.postId); }.bind(this)}
                              style={{
                                background: 'none', border: 'none', cursor: 'pointer', padding: '4px',
                                color: isDark ? '#777' : '#ccc', transition: 'color 0.15s ease',
                              }}
                              aria-label="Remove item"
                            >
                              <i className="fa fa-times" style={{ fontSize: '14px' }} />
                            </button>
                          </div>
                        </div>
                      );
                    }.bind(this))}
                  </div>

                  {/* Summary */}
                  <div style={{ padding: '16px 20px 0' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                      <span style={{ fontSize: '14px', fontWeight: '600', color: isDark ? '#ccc' : '#666' }}>Subtotal</span>
                      <span style={{ fontSize: '18px', fontWeight: '700', color: isDark ? '#fff' : '#1a1a1a' }}>
                        ${cart.reduce(function(sum, item) { return sum + ((Number(item.price) || 0) * (item.quantity || 1)); }, 0).toFixed(2)}
                      </span>
                    </div>
                    <p style={{ fontSize: '11px', color: isDark ? '#999' : '#888', margin: '0 0 16px' }}>
                      Shipping calculated at checkout
                    </p>

                    <button
                      onClick={function() { this.closeMobileCart(); this.props.history.push('/cart'); }.bind(this)}
                      style={{
                        width: '100%', backgroundColor: '#c9a84c', color: '#000',
                        border: 'none', borderRadius: '12px', cursor: 'pointer',
                        padding: '14px', fontSize: '15px', fontWeight: '700',
                        marginBottom: '8px',
                      }}
                    >
                      View Cart & Checkout
                    </button>
                    <button
                      onClick={this.closeMobileCart}
                      style={{
                        width: '100%', backgroundColor: 'transparent',
                        border: '1.5px solid ' + (isDark ? '#444' : '#ddd'),
                        borderRadius: '12px', cursor: 'pointer',
                        padding: '12px', fontSize: '14px', fontWeight: '600',
                        color: isDark ? '#ccc' : '#666',
                      }}
                    >
                      Continue Shopping
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          )}
          </CartContext.Consumer>
        );
      })()}

      {/* Mobile bottom tab bar — hidden on admin pages (admin has its own nav) */}
      {currentPath.indexOf('/admin') !== 0 && (() => {
        var activeTab = this.getActiveTab();
        var inactiveColor = '#8e8e93';
        var activeColor = '#c9a84c';
        var tabStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, paddingTop: '6px', paddingBottom: '2px', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'none', transition: 'color 200ms ease' };

        var tabs = [
          isLoggedIn ? { key: 'activity', icon: 'fa-envelope', label: 'Inbox', to: '/messages', auth: true } : { key: 'home', icon: 'fa-home', label: 'Home', to: '/' },
          { key: 'browse', icon: 'fa-compass', label: 'Browse', to: '/browse' },
          { key: 'sell', icon: 'fa-plus', label: 'Sell', to: '/sell', auth: true, alwaysGold: true },
          { key: 'orders', icon: 'fa-file-text-o', label: 'Orders', to: '/orders', auth: true },
          { key: 'profile', icon: null, label: 'You', to: null, auth: true, isSheet: true },
        ];

        var activityBadge = this.state.unreadMessages || 0;

        if (this.state.keyboardOpen || this.state.mobileSearchOpen || this.state.mobileCartOpen) return null;

        return (
          <div
            className="md:tw-hidden mobile-tab-bar"
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 50,
              backgroundColor: isDark ? 'rgba(26,26,26,0.92)' : 'rgba(255,255,255,0.92)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              borderTop: '1px solid ' + (isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.08)'),
              paddingBottom: 'env(safe-area-inset-bottom, 0px)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: '49px' }}>
              {tabs.map(function(tab) {
                var isActive = activeTab === tab.key;
                var color = isActive ? activeColor : (tab.alwaysGold ? activeColor : inactiveColor);

                if (tab.auth && !isLoggedIn) {
                  return (
                    <button
                      key={tab.key}
                      className="tab-shimmer"
                      onClick={function() { this.context.openAuthModal('login'); }.bind(this)}
                      style={Object.assign({}, tabStyle, { color: tab.alwaysGold ? activeColor : inactiveColor })}
                    >
                      {tab.isSheet ? (
                        <div style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: isDark ? '#333' : '#ddd' }} />
                      ) : (
                        <i className={'fa ' + tab.icon} style={{ fontSize: '20px' }} />
                      )}
                      <span style={{ fontSize: '10px', marginTop: '2px', fontWeight: isActive ? '600' : '400' }}>{tab.label}</span>
                    </button>
                  );
                }

                // "You" tab opens account sheet
                if (tab.isSheet) {
                  var sheetActive = this.state.accountSheetOpen;
                  return (
                    <button
                      key={tab.key}
                      className="tab-shimmer"
                      onClick={function() {
                        if (this.state.accountSheetOpen) {
                          this.setState({ accountSheetClosing: true });
                          this.unlockScroll();
                          setTimeout(function() { this.setState({ accountSheetOpen: false, accountSheetClosing: false }); }.bind(this), 280);
                        } else {
                          this.lockScroll();
                          this.setState({ accountSheetOpen: true, accountSheetClosing: false });
                        }
                      }.bind(this)}
                      style={Object.assign({}, tabStyle, { color: sheetActive ? activeColor : inactiveColor, position: 'relative' })}
                    >
                      <span style={{ position: 'relative', display: 'inline-block' }}>
                        <div style={{
                          width: '22px',
                          height: '22px',
                          borderRadius: '50%',
                          overflow: 'hidden',
                          border: '2px solid ' + (sheetActive ? activeColor : 'transparent'),
                          transition: 'border-color 200ms ease',
                          flexShrink: 0,
                        }}>
                          {profileImage ? (
                            <img src={profileImage} alt="" style={{
                              width: '100%', height: '100%', objectFit: 'cover', display: 'block',
                            }} />
                          ) : (
                            <div style={{
                              width: '100%', height: '100%',
                              backgroundColor: isDark ? '#333' : '#ddd',
                            }} />
                          )}
                        </div>
                        {notificationCount > 0 && (
                          <span style={{
                            position: 'absolute', top: '-2px', right: '-4px',
                            width: '8px', height: '8px', borderRadius: '50%',
                            backgroundColor: '#ef4444',
                            border: '1.5px solid ' + (isDark ? '#1a1a1a' : '#fff'),
                          }} />
                        )}
                      </span>
                      <span style={{ fontSize: '10px', marginTop: '2px', fontWeight: sheetActive ? '600' : '400' }}>{tab.label}</span>
                    </button>
                  );
                }

                return (
                  <Link
                    key={tab.key}
                    to={tab.to}
                    className="tw-no-underline tab-shimmer"
                    style={Object.assign({}, tabStyle, { color: color, position: 'relative' })}
                  >
                    <span style={{ position: 'relative', display: 'inline-block' }}>
                      <i className={'fa ' + tab.icon} style={{ fontSize: '20px' }} />
                      {tab.key === 'activity' && activityBadge > 0 && (
                        <span
                          style={{
                            position: 'absolute',
                            top: '-4px',
                            right: '-8px',
                            minWidth: '16px',
                            height: '16px',
                            borderRadius: '8px',
                            backgroundColor: '#c9a84c',
                            color: '#000',
                            fontSize: '9px',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 4px',
                          }}
                        >
                          {activityBadge > 9 ? '9+' : activityBadge}
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: '10px', marginTop: '2px', fontWeight: isActive ? '600' : '400' }}>{tab.label}</span>
                  </Link>
                );
              }.bind(this))}
            </div>
          </div>
        );
      })()}

      {/* Account sheet (iOS-style bottom sheet) */}
      {isLoggedIn && (this.state.accountSheetOpen || this.state.accountSheetClosing) && (() => {
        var closing = this.state.accountSheetClosing;
        var closeSheet = function() {
          this.setState({ accountSheetClosing: true });
          this.unlockScroll();
          setTimeout(function() { this.setState({ accountSheetOpen: false, accountSheetClosing: false }); }.bind(this), 280);
        }.bind(this);
        var navAndClose = function(path) {
          this.props.history.push(path);
          closeSheet();
        }.bind(this);
        var linkStyle = {
          display: 'flex', alignItems: 'center', gap: '14px',
          padding: '14px 24px', fontSize: '15px', fontWeight: '500',
          color: isDark ? '#fff' : '#1a1a1a',
          background: 'none', border: 'none', width: '100%', textAlign: 'left',
          cursor: 'pointer', textDecoration: 'none',
          transition: 'background-color 0.15s ease',
        };
        var iconStyle = { width: '20px', textAlign: 'center', color: isDark ? '#888' : '#999', fontSize: '16px' };
        var dividerStyle = { height: '1px', backgroundColor: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)', margin: '4px 24px' };

        return (
          <div
            className="md:tw-hidden"
            style={{ position: 'fixed', inset: 0, zIndex: 60, touchAction: 'none', overscrollBehavior: 'contain' }}
          >
            {/* Backdrop */}
            <div
              className={closing ? 'sheet-backdrop-closing' : 'sheet-backdrop'}
              onClick={closeSheet}
              onTouchMove={function(e) { e.preventDefault(); }}
              style={{
                position: 'absolute', inset: 0,
                backgroundColor: 'rgba(0,0,0,0.35)',
                backdropFilter: 'saturate(180%) blur(20px)',
                WebkitBackdropFilter: 'saturate(180%) blur(20px)',
                touchAction: 'none',
              }}
            />
            {/* Panel */}
            <div
              className={closing ? 'sheet-panel-closing' : 'sheet-panel'}
              style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                maxHeight: '80vh',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                backgroundColor: isDark ? 'rgba(26,26,26,0.97)' : 'rgba(255,255,255,0.97)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
                paddingBottom: 'calc(60px + env(safe-area-inset-bottom, 0px))',
                boxShadow: '0 -8px 40px rgba(0,0,0,0.15)',
              }}
            >
              {/* Drag handle */}
              <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 6px' }}>
                <div style={{ width: '36px', height: '4px', borderRadius: '2px', backgroundColor: isDark ? '#444' : '#d1d1d6' }} />
              </div>

              {/* User header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 24px 16px' }}>
                <div style={{
                  width: '44px', height: '44px', borderRadius: '50%',
                  overflow: 'hidden',
                  border: '2px solid #c9a84c', flexShrink: 0,
                }}>
                  {profileImage ? (
                    <img src={profileImage} alt="" style={{
                      width: '100%', height: '100%', objectFit: 'cover', display: 'block',
                    }} />
                  ) : (
                    <div style={{
                      width: '100%', height: '100%',
                      backgroundColor: isDark ? '#333' : '#ddd',
                    }} />
                  )}
                </div>
                <div>
                  <div style={{ fontWeight: '600', fontSize: '16px', color: isDark ? '#fff' : '#1a1a1a' }}>{username}</div>
                  <div style={{ fontSize: '12px', color: isDark ? '#888' : '#999', marginTop: '1px' }}>
                    {this.state.userRole === 'admin' ? 'Administrator' : 'Member'}
                  </div>
                </div>
              </div>

              <div style={dividerStyle} />

              {/* Notifications section */}
              {(() => {
                var notifItems = this.getNotificationItems();
                if (notifItems.length === 0) return null;
                var notifIconStyle = { width: '16px', textAlign: 'center', flexShrink: 0, fontSize: '13px' };
                return (
                  <React.Fragment>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 24px 6px' }}>
                      <span style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: isDark ? '#888' : '#999' }}>
                        Notifications
                        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: '18px', height: '18px', borderRadius: '9px', backgroundColor: '#c9a84c', color: '#000', fontSize: '10px', fontWeight: '700', marginLeft: '6px', padding: '0 5px' }}>
                          {notifItems.length}
                        </span>
                      </span>
                      <button
                        onClick={function() { this.markAllRead(); }.bind(this)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: '600', color: '#c9a84c', padding: 0 }}
                      >
                        Mark all read
                      </button>
                    </div>
                    <div style={{ maxHeight: '180px', overflowY: 'auto', padding: '0 12px 4px' }}>
                      {notifItems.slice(0, 5).map(function(item, idx) {
                        return (
                          <button
                            key={item.key || idx}
                            onClick={function() {
                              if (item.systemNotifId) this.dismissSystemNotification(item.systemNotifId, item.key);
                              else {
                                if (item.dismissId) this.dismissPriceWatch(item.dismissId);
                                if (item.key) this.dismissNotif(item.key);
                              }
                              if (item.link) navAndClose(item.link);
                              else closeSheet();
                            }.bind(this)}
                            style={{
                              display: 'flex', alignItems: 'center', gap: '10px',
                              width: '100%', textAlign: 'left', padding: '10px 12px',
                              fontSize: '13px', lineHeight: '1.4',
                              background: item.isSystem ? (isDark ? 'rgba(239,68,68,0.08)' : 'rgba(239,68,68,0.04)') : 'none',
                              border: 'none', borderRadius: '10px', cursor: 'pointer',
                              color: item.isSystem ? '#ef4444' : (isDark ? '#fff' : '#1a1a1a'),
                              transition: 'background-color 0.15s ease',
                            }}
                          >
                            <i className={'fa ' + item.icon} style={Object.assign({}, notifIconStyle, { color: item.isSystem ? '#ef4444' : '#c9a84c' })} />
                            <span style={{ flex: 1, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{item.text}</span>
                            <i className="fa fa-chevron-right" style={{ fontSize: '10px', color: isDark ? '#555' : '#ccc', flexShrink: 0 }} />
                          </button>
                        );
                      }.bind(this))}
                    </div>
                    <div style={dividerStyle} />
                  </React.Fragment>
                );
              })()}

              {/* Navigation links */}
              <button onClick={function() { navAndClose('/shop/' + username); }} style={linkStyle}>
                <i className="fa fa-home" style={iconStyle} />
                My Shop
              </button>
              <button onClick={function() { navAndClose('/orders'); }} style={linkStyle}>
                <i className="fa fa-shopping-bag" style={iconStyle} />
                Orders
              </button>
              <button onClick={function() { navAndClose('/settings'); }} style={linkStyle}>
                <i className="fa fa-cog" style={iconStyle} />
                Settings
              </button>

              {this.state.userRole === 'admin' && (
                <React.Fragment>
                  <div style={dividerStyle} />
                  <button onClick={function() { navAndClose('/admin'); }} style={Object.assign({}, linkStyle, { color: '#c9a84c' })}>
                    <i className="fa fa-shield" style={Object.assign({}, iconStyle, { color: '#c9a84c' })} />
                    Admin Dashboard
                  </button>
                  <button onClick={function() { navAndClose('/admin/analytics'); }} style={Object.assign({}, linkStyle, { color: '#c9a84c' })}>
                    <i className="fa fa-bar-chart" style={Object.assign({}, iconStyle, { color: '#c9a84c' })} />
                    Analytics
                  </button>
                </React.Fragment>
              )}

              <div style={dividerStyle} />

              {/* Theme toggle */}
              <div style={{ padding: '0' }}>
                <ThemeToggle />
              </div>

              <div style={dividerStyle} />

              {/* Logout */}
              <button
                onClick={function() { closeSheet(); this.handleLogout(); }.bind(this)}
                style={Object.assign({}, linkStyle, { color: '#ef4444' })}
              >
                <i className="fa fa-sign-out" style={Object.assign({}, iconStyle, { color: '#ef4444' })} />
                Log Out
              </button>
            </div>
          </div>
        );
      })()}

      </React.Fragment>
        );
      }}
      </GameContext.Consumer>
    );
  }
}

export default withRouter(LayoutNavbar);
